import React from "react";
import {
  FormField,
  FormRadioCheckboxButton,
  FormRadioCheckboxGroup,
  Text,
  Button,
  Box
} from "@nef/core";
import { useWizard } from "react-use-wizard";
import { Controller, useFormContext } from "react-hook-form";

import StyledPricingAgentInformation from "../../../../../styles/PricingAgentInformation.styles";


const PricingAgentInformation = () => {
  const { nextStep, previousStep } = useWizard();
  const { control, formState: { errors, isDirty }, watch } = useFormContext();

  const [watchIsMPID, watchIsPricingAgent] = watch([
    "isMPID",
    "isPricingAgent"
  ]);
  return (
    <>
      <StyledPricingAgentInformation className="pricing-agent-information">
        <Controller
          name="isPricingAgent"
          control={control}
          rules={{ required: true }}
          render={({ field: { onChange, value } }) => (
            <FormRadioCheckboxGroup
              id="isPricingAgent"
              name="isPricingAgent"
              type="radio"
              label="Are you a Pricing Agent?"
              value={value}
              onChange={e => onChange(e.value === "true")}
            >
              <FormRadioCheckboxButton value={true} label="Yes" key={1} />
              ,
              <FormRadioCheckboxButton value={false} label="No" key={2} />
            </FormRadioCheckboxGroup>
          )}
        />
        {watch("isPricingAgent") && (
          <Controller
            name="isMPID"
            control={control}
            rules={{ required: true }}
            render={({ field: { onChange, value } }) => (
              <FormRadioCheckboxGroup
                id="isMPID"
                name="isMPID"
                type="radio"
                label="Do you have a Market Participation ID?"
                value={value}
                onChange={e => onChange(e.value === "true")}
              >
                <FormRadioCheckboxButton value={true} label="Yes" key={1} />
                ,
                <FormRadioCheckboxButton value={false} label="No" key={2} />
              </FormRadioCheckboxGroup>
            )}
          />
        )}

        {watchIsMPID && watchIsPricingAgent && (
          <Controller
            name="MPID"
            control={control}
              rules={{
              required: true,
              minLength: { value:4, message: "MPID length should be 4 characters "},
              maxLength: { value:4, message: "MPID length should be 4 characters "}  
            }  
          }    
            render={({ field: { onChange, value, name }, fieldState, formState }) => (
              <FormField
                name={name}
                label="Enter your MPID"
                value={value}
                maxLength={4}
                onChange={onChange}
                invalid={fieldState.error != null}
                feedback={fieldState.error?.message}
              />
            )}
          />
        )}

        {watchIsPricingAgent && !watchIsMPID && (
          <Text>An MPID request form will be sent to your email.</Text>
        )}
        <br />
        <br />
        <div className="action-buttons">
          <Button className="button" size="lg" onClick={() => previousStep()}>
            Back
          </Button>
          <Button className="button" size="lg" onClick={() => nextStep()}>
            Next
          </Button>
        </div>
      </StyledPricingAgentInformation>
    </>
  );
};
export default PricingAgentInformation;
